<template>
  <v-menu
    ref="menu"
    v-model="menu"
    lazy
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template #activator="{ on }">
      <v-text-field
        :id="id"
        :disabled="disabled"
        v-model="dateTime"
        :label="label"
        :rules="rules"
        return-masked-value
        :mask="mask"
        ref="textField"
        validate-on-blur
        @blur="blurValues"
        @keyup.enter.exact="$emit('keyupEnter')"
        @click="$emit('click')"
      >
        <template v-slot:append>
          <v-icon @click="openMenu()">event</v-icon>
        </template>
      </v-text-field>
    </template>
    <div>
      <v-btn id="toggle" dark text icon @click="toggle()">
        <v-icon dark>{{this.picker.date ? 'access_time': 'event'}}</v-icon>
      </v-btn>
      <v-date-picker
        :id="id + '_date_picker'"
        @change="toggle('date')"
        reactive
        v-model="date"
        ref="datePicker"
        :disabled="disabled"
        v-if="this.picker.date"
        locale="pt-br"
        style="display: table-cell;"
      ></v-date-picker>
      <!-- // usado o @click:minute pois quando clicava no mesmo minuto que já estava selecionado, não estava saindo do timepicker -->
      <v-time-picker
        :id="id + '_time_picker'"
        @click:minute="toggle('time')"
        ref="timePicker"
        reactive
        :disabled="disabled"
        v-if="this.picker.time"
        v-model="time"
        format="24hr"
        style="display: table-cell;"
      ></v-time-picker>
      <!-- v-model="time" -->
    </div>
  </v-menu>
</template>

<style>
#toggle {
  z-index: 50;
  position: absolute;
  right: 10px;
  margin: 0;
  top: 35px;
}

.v-time-picker-title {
  display: flex !important;
  justify-content: flex-start !important;

  align-items: center !important;
}

.v-picker__title {
  height: 88px !important;
  display: flex;
  /* padding: 0 0 0 16px; */
}

.v-picker__body {
  height: 290px !important;
}

.v-date-picker-title__date {
  font-size: 32px !important;
  margin-bottom: -6px !important;
}
</style>

<script>
export default {
  data () {
    return {
      menu: false,
      picker: {
        date: false,
        time: false
      },
      date: '',
      time: '',
      dateTime: '',
      mask: '##/##/#### ##:##'
    }
  },
  props: {
    id: {
      default: 'date_time_id'
    },
    value: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    timePicker: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultHour: {
      type: String,
      default: ''
    },
    nullable: {
      type: Boolean,
      default: true
    },
    rules: {}
  },
  watch: {
    value (val) {
      this.setValues(val)
    },
    timePicker (timePicker) {
      if (timePicker) {
        this.mask = '##/##/#### ##:##'
      } else {
        this.mask = '##/##/#### 00:00'
        // coloca 00 no time para mandar 00 pro banco
        this.time = '00:00'
      }
    }
  },
  mounted () {
    this.setValues()
  },
  methods: {
    inputField (val) {
      this.dateTime = val
    },
    // Função criada para setar os valores nas variaveis corretas quando são alterados
    setValues (dateTime = this.value) {
      if (dateTime) {
        this.dateTime = this.moment(dateTime).format('DD/MM/YYYY HH:mm')
        this.date = this.moment(dateTime).format('YYYY-MM-DD')
        this.time = this.moment(dateTime).format('HH:mm')
      } else {
        this.dateTime = ''
        this.date = ''
        this.time = ''
        // tem que zerar o internalValue tbm pois quando era digitado uma data invalida e colocava vazio não estava recebendo o vazio.
        this.$refs.textField.internalValue = ''
      }
    },
    openMenu (e) {
      this.$emit('click')
      // caso não tenha data selecionada, já preenche com a data atual
      if (!this.value) {
        this.dateTime = this.moment().format('DD/MM/YYYY ' + (this.defaultHour === '' ? 'HH:mm' : this.defaultHour))
        this.updateValues()
      }
      setTimeout(() => {
        this.menu = true
        this.picker.time = false
        this.picker.date = true
        this.$refs.textField.$refs.input.focus()
      }, 10)
    },
    blurValues () {
      // Como passa o valor em formato brasileiro, então coloca pro moment receber em DD/MM/YYYY HH:mm
      if (!this.menu) {
        let dateTimeLength = this.dateTime.length
        // caso o usuário tenha colocado apenas a data ou algum valor menor, então insere a hora default e caso não tenha a hora atual
        if (dateTimeLength <= 11) {
          // já coloca o moment pois quando o usuário digita algum numero o moment consegue, colocar a data corrente, porem não coloca a hora corrente
          let dateTimeAux = this.moment(this.dateTime, 'DD/MM/YYYY HH:mm')
          // Codigo abaixo serve para isnerir a hora default ou a hora corrente
          if (dateTimeAux.isValid()) {
            this.dateTime = dateTimeAux.format('DD/MM/YYYY ' + (this.defaultHour === '' ? this.moment().format('HH:mm') : this.defaultHour))
          }
        // caso o usuário não tenha completado as horas, então termina de inserir com zeros
        } else if (dateTimeLength > 11 && dateTimeLength < 16) {
          if (dateTimeLength === 12) this.dateTime = this.dateTime + '0:00'
          else if (dateTimeLength === 13) this.dateTime = this.dateTime + ':00'
          else if (dateTimeLength === 14) this.dateTime = this.dateTime + '00'
          else if (dateTimeLength === 15) this.dateTime = this.dateTime + '0'
        }
        this.updateValues('blur')
      } else {
        this.setDateTime()
      }
    },
    // event serve para saber qual emit sera acionado apos mudar os valores
    updateValues (event = '') {
      let dateTime = this.moment(this.dateTime, 'DD/MM/YYYY HH:mm')
      // let date, time
      if (dateTime.isValid()) {
        dateTime = dateTime.format('YYYY-MM-DD HH:mm')
      } else {
        // caso não tenha um valor e o nullable está ativo então limpa o campo
        // caso o nullable esteja desativo(a data não pode ser invalida ou vazia) então seta a data atual
        dateTime = (this.nullable) ? '' : this.moment().format('YYYY-MM-DD HH:mm')
      }
      let result = dateTime ? this.moment(dateTime).format('YYYY-MM-DD HH:mm') : ''
      this.$emit('input', result)
      if (event !== '') this.$emit(event, result)
      this.menu = false
    },
    toggle (type) {
      // Quando o usuário clica em alguma data, verifica se a propriedade timePicker está ativa, se tiver abre o componente de horas e caso não tenha valor preenchido já preenche.
      if (type === 'date') {
        this.setDateTime()
        this.picker.date = false
        if (this.timePicker) {
          this.picker.time = true
        } else {
          this.menu = false
        }
      } else if (type === 'time') {
        this.setDateTime()
        this.picker.date = false
        this.picker.time = false
        this.menu = false
      } else {
        this.picker.date = !this.picker.date
        this.picker.time = !this.picker.time
      }
    },
    // função setDateTime serve para setar a data e a hora quando vem pelos componentes pickers
    setDateTime () {
      // caso não tenha nem data nem hora so retorna e não preenche
      if (!this.date && !this.time) return 0
      // caso o timePicker esteja desativado significa que pode colocar so a data e as horas vem bloqueado, no caso nas horas coloca o horario padrão ou as horas correntes
      if (!this.time) {
        this.time = (this.defaultHour === '' ? this.moment().format('HH:mm') : this.defaultHour)
      }
      // caso não tenha alguma data insere a corrente
      if (!this.date) {
        this.date = this.moment().format('YYYY-MM-DD')
      }
      this.dateTime = this.moment(this.date + ' ' + this.time).format('DD/MM/YYYY HH:mm')
      this.$emit('input', this.date + ' ' + this.time)
      // foca novamente no field, para entrar no blur quando sair do campo
      this.$refs.textField.$refs.input.focus()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/PDateTime.vue